import React, { useEffect, useRef, useState } from "react";
import Poster1 from "../assets/img/tms2/poster-1.png";
import Poster2 from "../assets/img/tms2/poster-2.png";

const delay = 5000;
const IMAGES = [Poster2, Poster1];

const Slideshow = ({ onCloseClick, data = IMAGES }) => {
  const [index, setIndex] = useState(0);
  const timeoutRef = useRef(null);

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIdex) =>
          prevIdex === data.length - 1 ? 0 : prevIdex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index, data.length]);

  return (
    <article className="flex items-center mx-auto overflow-hidden slideshow">
      {onCloseClick && (
        <div
          className="fixed top-0 left-0 z-10 w-screen h-screen cursor-pointer"
          onClick={onCloseClick}
        />
      )}
      <div
        className="flex items-center h-[70vh] md:h-[90vh] transition-transform duration-500 whitespace-nowrap"
        style={{ transform: `translate3d(${-index * 100}%, 0,0)` }}
      >
        {data.map((item) => (
          <div
            className="flex items-center justify-center flex-shrink-0 w-full h-full text-center transition-transform translate-z-0"
            key={item}
          >
            <img
              className={
                "object-fill w-auto h-full border border-gray-700 bg-black"
              }
              src={item}
              alt="Poster The Masked Singer 2023"
            />
          </div>
        ))}
      </div>
    </article>
  );
};

export default React.memo(Slideshow);
